// extracted by mini-css-extract-plugin
export default {"sfltPage":"SFLT_sfltPage__WoluC","footer":"SFLT_footer__IPHcc"};